import { PosSettingsService } from 'src/app/services/pos-settings.service';
import { VendorService } from '../../../../services/Vendor.service';
import { GeneralService } from '../../../../services/general.service';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { ICountry, IStates } from 'src/app/Shared/model/GeneralModel';
import { ANGULAR_MODULES, GENERAL_COMPONENTS, Operational_COMPONENTS, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { IVendorFormOnly, IVendorInfo, IVendorProductModel } from 'src/app/Shared/model/VendorsModel';
import { ProductService } from 'src/app/services/Product.service';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { IVendorFormGeneralSettings, IVendorGeneralSettings } from 'src/app/Shared/model/SettingsModel';
import { VendorSettingService } from 'src/app/services/VendorSetting.service';
import { WordReplacePipe } from "../../../../Shared/word-replace.pipe";
import { MandatoryfieldsettingService } from 'src/app/services/MandatoryFieldSetting.service';
import { UserPermissionHandlerDirective } from 'src/app/Shared/userPermissionHandler.directive';
import { IUserPermissionHandler } from 'src/app/Shared/model/CommonModel';
import { EActionTypes, ECountrycode, EUserSecurityFunctionID } from 'src/app/Shared/enum';
import { IdefaultPosCommissionSetting } from 'src/app/Shared/Interfaces/IPOSSettings';
import { FlexDecimalPipe } from 'src/app/Shared/FlexDecimalPipe.pipe';
import { PercentageFormatterDirective } from 'src/app/Shared/percentageFormatter.directive';

@Component({
  selector: 'app-ops-createupdate-vendor',
  standalone: true,
  imports: [GENERAL_COMPONENTS, Operational_COMPONENTS, SYNCFUSION_MODULES, ANGULAR_MODULES,
    LoaderComponent, DialogModule, WordReplacePipe, UserPermissionHandlerDirective, FlexDecimalPipe, PercentageFormatterDirective],
  templateUrl: './ops-createupdate-vendor.html',
  styleUrl: './ops-createupdate-vendor.scss'
})
export class OpsCreateVendor implements OnInit {
  logoPreviewUrl: string = './assets/images/NoPhoto.svg';
  isCollapsed: boolean = true;
  vendorForm: FormGroup;
  loaderIcon: Promise<boolean>;
  private subscriptions: Subscription[] = [];
  CountryList: ICountry[] = [];
  response;
  StateList: IStates[] = [];
  vendorProductForm: FormGroup;
  VendorProductsList: IVendorProductModel[] = [];
  VendorTypeList = [
    {
      VtyTxtVendorTypeValue: '',
      VtyTxtVendorType: 'Select Type'
    },
    {
      VtyTxtVendorTypeValue: 'P',
      VtyTxtVendorType: 'Permanent'
    },
    {
      VtyTxtVendorTypeValue: 'T',
      VtyTxtVendorType: 'Temporary'
    }
  ];

  public PhoneNumberMask: String = '(000)000-0000';

  public PhoneEXTMask: String = '000';

  showZipCodeAsNumber: boolean;
  maxDate: Date;
  showModal: boolean = false;
  categoriesList = [];
  productList = [];
  filteredProductList = [];

  @ViewChild('GridVenProd', { static: false }) public gridVenProd: GridComponent;

  vendorProfileChanged = false;
  imageName = '';
  imageUrl;
  imageBase64;
  mandatoryFields = [];

  fieldLabels: Record<string, string> = {
    firstName: 'First Name',
    lastName: 'Last Name',
    middleName: 'Middle Name',
    address: 'Address',
    cellPhone: 'Cell Phone',
    email: 'Email',
    telephone: 'Telephone',
    workPhone: 'Work Phone',
    DLexpiryDate: 'DL Expiry Date',
    driverLicense: 'Driver License#',
    companyName: 'Company Name',
    vendorSince: 'Vendor Since',
    facebookID: 'facebook ID',
    linkedinID: 'linkedin ID',
    vendorProfile: 'Vendor Profile Image'
  };

  timestamp = new Date().getTime();
  IsManualVendorId: boolean = false;

  VendorGeneralSetting: IVendorFormGeneralSettings = {} as IVendorFormGeneralSettings;
  @Output() CancelView = new EventEmitter<boolean>();
  @Output() isFormDirty: EventEmitter<any> = new EventEmitter<any>();
  @Input() VId: number = 0;
  @ViewChild('marketVendorId') marketVendorId: any;

  createPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID['Vendor'], Action: EActionTypes.CREATE };
  editPermissionHandlerData: IUserPermissionHandler = { FunctionId: EUserSecurityFunctionID['Vendor'], Action: EActionTypes.EDIT };
  createOrEditPermissionHandler: IUserPermissionHandler;

  defaultPosCommissionSetting: IdefaultPosCommissionSetting = {
    FlatCommissionPos: 0.00,
    ConsignmentCommission: 0.00,
    AllowCommissionOverride: false
  };

  originalFlatCommission = 0;
  hasTransactionsAfterLastPayout = false;
  enableInventoryControl = false;
  hasInventoryTransactions = false;

  IsAddressMandatory: boolean = false;

  constructor(private fb: FormBuilder,
    private toastr: ToastrService,
    private generalService: GeneralService,
    private ProductService: ProductService,
    private vendorService: VendorService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private vendorSettingService: VendorSettingService,
    private mandatoryFieldService: MandatoryfieldsettingService,
    private PosSettingsService: PosSettingsService,
    private router: Router,) { }

  ngOnInit(): void {
    this.loadMandatoryFields();
    this.getVendorGeneralSettings();
    this.getVendorCommissionUpdateStatus();
    this.getASCloudLicenseSettings();
    this.vendorForm = this.fb.group(
      {
        firstName: ['', [Validators.maxLength(50)]],
        middleName: ['', [Validators.maxLength(50)]],
        lastName: ['', [Validators.maxLength(50)]],
        companyName: ['', [Validators.maxLength(50)]],
        address: ['', [Validators.maxLength(80)]],
        address2: ['', [Validators.maxLength(80)]],
        city: [''],
        state: [''],
        zipCode: [''],
        country: [''],
        countryCode: [''],
        email: ['',
          [
            Validators.maxLength(75),
            Validators.pattern(
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/
            )
          ]],
        vendorType: ['P'],
        vendorSince: [Date],
        cellPhone: ['', [Validators.minLength(10), Validators.maxLength(12)]],
        telephone: [''],
        workPhone: [''],
        DLexpiryDate: [Date],
        driverLicense: [''],
        facebookID: [''],
        linkedinID: [''],
        vendorProfile: [''],
        venTxtPhotoFile: [''],
        marketId: [0, [Validators.required]],
        marketVendorId: ['', [Validators.required]],
        vendorId: [0, [Validators.required]],
        ApplyFlatCommissionPos: [false],
        EnableConsignmentCommission: [false],
        FlatCommissionPos: [''],
        ConsignmentCommission: [''],
        AutoDeductRent: [false],
        AllowWebInquiry: [false]
      }
    );

    this.vendorProductForm = this.fb.group(
      {
        vProductId: [0, Validators.required],
        productId: [0, Validators.required],
        productCategoryId: [0, Validators.required],
        productCategory: ['', Validators.required],
        productName: ['', Validators.required],
        priority: [false, Validators.required]
      }
    );

    this.maxDate = new Date();
    this.getCountries();

    this.CountryList.push({
      Name: "Select Country",
      Code: 0,
      DailInCode: 0
    });
    if (this.VId != null || this.VId != undefined) {
      this.getVendorDetails();
    }
    if (this.VId != 0 && this.VId != null) {
      this.createOrEditPermissionHandler = this.editPermissionHandlerData;
    } else {
      this.createOrEditPermissionHandler = this.createPermissionHandlerData;
    }
  }

  ngAfterViewInit() {

    this.subscriptions.push(this.vendorForm.valueChanges.subscribe(() => {
      if (this.vendorForm.dirty) {
        this.isFormDirty.emit(true);
      }
    }));

    this.marketVendorId.nativeElement.focus();
  }

  getVendorDetails() {
    this.loaderIcon = Promise.resolve(true);
    this.VendorProductsList = [];

    this.subscriptions.push(
      this.vendorService.GetVendorFormInfo(this.VId).subscribe((res: any) => {
        if (!res) {
          this.toastr.error($localize`Something went wrong`, $localize`Failed`, this.sharedHTMLSettings.ToasterConfig);
          this.loaderIcon = Promise.resolve(false);
          return;
        }
        const result = res;

        this.StateList = [];

        this.subscriptions.push(
          this.generalService.getStates(result.CountryCode).subscribe((response: IStates[]) => {
            this.StateList = response;

            this.vendorForm.patchValue({
              vendorId: result.VendorId,
              marketVendorId: result.MarketVendorId,
              firstName: result.FirstName,
              lastName: result.LastName,
              middleName: result.MiddleName,
              address: result.Address,
              address2: result.Address2,
              state: result.State, // safe now, dropdown has options
              city: result.City,
              zipCode: result.ZipCode,
              country: result.Country,
              countryCode: result.CountryCode,
              email: result.Email,
              cellPhone: result.CellPhone,
              vendorType: this.VId === 0 ? 'P' : result.VendorType,
              marketId: result.MarketId,

              DLexpiryDate: this.getValidDate(result.DLExpiryDate),
              driverLicense: result.DriverLicenseNumber,
              vendorSince: result.VendorSince,
              telephone: result.Telephone,
              workPhone: result.WorkPhone,

              companyName: result.CompanyName,
              vendorProfile: result.VendorProfile != '' && result.VendorProfile != null
                ? `${result.VendorProfile}?timestamp=${this.timestamp}`
                : '',
              facebookID: result.FaceBookId,
              linkedinID: result.LinkedInID,
              venTxtPhotoFile: result.VenTxtPhotoFile ?? '',
              ApplyFlatCommissionPos: result.ApplyFlatCommissionPos,
              EnableConsignmentCommission: result.EnableConsignmentCommission,
              FlatCommissionPos: (result.FlatCommissionPos).toFixed(2) ?? 0.00,
              ConsignmentCommission: (result.ConsignmentCommission).toFixed(2) ?? 0.00,
              AutoDeductRent: result.AutoDeductRent,
              AllowWebInquiry: result.AllowWebInquiry
            });

            this.originalFlatCommission = Number(res.FlatCommissionPos);
            this.showZipCodeAsNumber = result.CountryCode == 1;
            if (this.VendorGeneralSetting.IsVendorIdManual && this.VId == 0) {
              this.vendorForm.patchValue({ MarketVendorId: '' });
            }


            setTimeout(() => {
              const flatInput = document.querySelector<HTMLInputElement>(
                'input[formControlName="FlatCommissionPos"]'
              );

              const consInput = document.querySelector<HTMLInputElement>(
                'input[formControlName="ConsignmentCommission"]'
              );

              flatInput?.dispatchEvent(new FocusEvent('blur'));
              consInput?.dispatchEvent(new FocusEvent('blur'));
            });
            this.VendorProductsList = result.VendorProductsList;
            this.sortVendorProducts();
            this.getDefaultPOSCommissions();
            if (this.VId == 0) {
              this.vendorForm.get('countryCode')?.setValue(this.CountryList[1].Code);
              this.vendorForm.get('country')?.setValue(this.CountryList[1].Name);
              this.onCountryChange();
            }
            this.loaderIcon = Promise.resolve(false);
          })
        );
      }, () => this.loaderIcon = Promise.resolve(false))
    );
  }

  removeVendorPhoto() {
    this.vendorForm.patchValue({
      vendorProfile: ''
    });
    //this.logoPreviewUrl = './assets/images/NoPhoto.svg';
  }

  handleToggle(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  getCountries() {
    const sub = this.generalService.getCountries().subscribe((response: ICountry[]) => {
      this.CountryList = this.CountryList.concat(response);
      if (this.VId == 0) {
        this.vendorForm.patchValue({
          countryCode: this.CountryList[1].Code,
          country: this.CountryList[1].Name
        });
        this.onCountryChange()
      }
    });
    this.subscriptions.push(sub);
  }

  onCountryChange() {
    this.vendorForm.patchValue({
      city: '',
      state: '',
      zipCode: '',
      cellPhone: '',
      telephone: '',
      workPhone: ''
    });

    this.StateList = [];

    const selectedCountry = this.CountryList.find(ct => ct.Code == this.vendorForm.value['countryCode']);
    if (selectedCountry != undefined || selectedCountry != null) {
      this.showZipCodeAsNumber = selectedCountry.Code != 1 ? false : true;
      this.subscriptions.push(this.generalService.getStates(selectedCountry.Code).subscribe((response: IStates[]) => {
        this.StateList = this.StateList.concat(response);
      }));
    }
  }

  validateVendorSinceDate(inputValue: any) {

    if (!inputValue) {
      this.vendorForm.patchValue({
        VendorSince: [Date]
      })
      return
    }
    if (!inputValue || isNaN(new Date(inputValue).getTime())) {
      this.toastr.warning($localize`Please enter a valid date in MM/dd/yyyy format.`, $localize`retry`, this.sharedHTMLSettings.ToasterConfig);
      this.vendorForm.patchValue({
        VendorSince: [Date]
      })
    }
    if (inputValue > new Date()) {
      this.toastr.warning($localize`Please check entered date`, $localize`retry`, this.sharedHTMLSettings.ToasterConfig);
      this.vendorForm.patchValue({
        VendorSince: [Date]
      })
    }
  }


  UpdateVendorAddressValidation() {

    if ((this.vendorForm.get('city').value != null && this.vendorForm.get('city').value.trim() != '') ||
      (this.vendorForm.get('zipCode').value != null && this.vendorForm.get('zipCode').value.trim() != '') ||
      (this.vendorForm.get('state').value != null && this.vendorForm.get('state').value.trim() != '')) {

      this.vendorForm.get('city').setValidators([Validators.required]);
      this.vendorForm.get('zipCode').setValidators([Validators.required]);
      this.vendorForm.get('state').setValidators([Validators.required]);

      ['city', 'zipCode', 'state'].forEach(f => {
        if (!this.mandatoryFields.includes(f)) {
          this.mandatoryFields.push(f);
        }
      });
    } else {
      if (!this.IsAddressMandatory) {
        this.vendorForm.get('city').clearValidators();
        this.vendorForm.get('zipCode').clearValidators();
        this.vendorForm.get('state').clearValidators();

        this.mandatoryFields = this.mandatoryFields.filter(
          f => !['city', 'zipCode', 'state'].includes(f)
        );
      }
    }
    this.vendorForm.get('city').updateValueAndValidity();
    this.vendorForm.get('zipCode').updateValueAndValidity();
    this.vendorForm.get('state').updateValueAndValidity();

    this.zipCodeValidator();
  }

  openModal() {
    this.getallproducts();
    this.showModal = true;
  }

  onModalClosed() {
    this.showModal = false;
  }

  SaveVendorProduct(e) {
    e.preventDefault();
    this.loaderIcon = Promise.resolve(true);
    if (this.vendorProductForm.valid) {
      const newVproduct: IVendorProductModel = {
        Priority: this.vendorProductForm.get('priority').value,
        ProductCategory: this.vendorProductForm.get('productCategory').value,
        ProductCategoryId: this.vendorProductForm.get('productCategoryId').value,
        ProductId: this.vendorProductForm.get('productId').value,
        ProductName: this.vendorProductForm.get('productName').value,
        VendorId: this.VId,
        VProductId: this.vendorProductForm.get('vProductId').value,
      };

      if (this.VendorProductsList.find(x => x.ProductId == newVproduct.ProductId)) {
        this.toastr.error($localize`Already Exists`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
        this.loaderIcon = Promise.resolve(false);
        return;
      }

      if (this.VendorProductsList.length == 0) {
        newVproduct.Priority = true;
      }

      this.VendorProductsList.push(
        newVproduct
      );
      this.sortVendorProducts();

      if (newVproduct.Priority) {
        this.VendorProductsList.forEach(x => x.Priority = (x.ProductId == newVproduct.ProductId ? true : false))
      }
      this.gridVenProd.refresh();
      this.CancelVendorProductSave();

      if (this.VId != 0) {
        this.saveVendorProductAdded();
      } else {
        // New vendor cannot save product until vendor is created
        this.toastr.success($localize`New product added to list`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    } else {
      this.toastr.error($localize`please enter all fields`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
      this.loaderIcon = Promise.resolve(false);
    }
  }

  private saveVendorProductAdded(deletedProduct?: IVendorProductModel, deletedIndex?: number): void {
    this.subscriptions.push(
      this.vendorService.SaveOrUpdateVendorProducts(this.VendorProductsList, this.VId).subscribe({
        next: (res: any) => {
          this.response = res;
          if (this.response.Success) {
            this.getVendorProducts();
            this.toastr.success(this.response.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
          } else {
            // Restore deleted product
            if (deletedProduct && deletedIndex !== undefined) {
              this.VendorProductsList.splice(deletedIndex, 0, deletedProduct);
              this.VendorProductsList = [...this.VendorProductsList];
              this.gridVenProd.dataSource = this.VendorProductsList;
              this.gridVenProd.refresh();
            }
            this.toastr.error(this.response.Message, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          }
          this.loaderIcon = Promise.resolve(false);
        },
        error: () => {
          if (deletedProduct && deletedIndex !== undefined) {
            this.VendorProductsList.splice(deletedIndex, 0, deletedProduct);
            this.VendorProductsList = [...this.VendorProductsList];
            this.gridVenProd.dataSource = this.VendorProductsList;
            this.gridVenProd.refresh();
          }
          this.loaderIcon = Promise.resolve(false);
          this.toastr.error($localize`Something Went Wrong`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
        }
      })
    );
  }

  private getVendorProducts(): void {
    this.subscriptions.push(this.vendorService.GetVendorProductsById(this.VId).subscribe({
      next: (res: any) => {
        this.VendorProductsList = res?.body ?? [];
        this.sortVendorProducts();
        this.gridVenProd.dataSource = this.VendorProductsList;
        this.gridVenProd.refresh();
      },
      error: () => {
        this.toastr.error($localize`Something Went Wrong`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
      }
    })
    );
  }

  private sortVendorProducts(): void {
    this.VendorProductsList = [...this.VendorProductsList].sort(
      (a, b) => a.ProductName.localeCompare(b.ProductName)
    );
  }

  CancelVendorProductSave() {
    this.vendorProductForm.patchValue({
      vendorId: 0,
      vProductId: 0,
      productId: 0,
      productCategoryId: 0,
      productName: "",
      productCategory: "",
      priority: false,
    });
    this.onModalClosed()
  }

  getallproducts() {

    this.subscriptions.push(this.ProductService.getProducts().subscribe((res: any) => {
      this.categoriesList = [];
      this.productList = [];
      this.filteredProductList = [];

      res.map((el, i) => {
        const ob = {
          ProductId: el.ProductId,
          ProductName: el.ProductName,
          ProductCategory: el.CategoryName,
          ProductCategoryId: el.ProductCategoryId,
          IsInActive: el.Status,
        }
        this.productList.push(ob);
      });

      res.filter((value, index, self) => self.findIndex(obj => obj.ProductCategoryId === value.ProductCategoryId) === index).map((el, i) => {
        const ob2 = {
          ProductCategory: el.CategoryName,
          ProductCategoryId: el.ProductCategoryId,
        }
        this.categoriesList.push(ob2);
      });
      this.filteredProductList = this.productList;
    }));
  }

  onCategoryChange(event: any): void {
    const selectedId = (event.target as HTMLSelectElement).value;
    this.filteredProductList = this.productList.filter(x => x.ProductCategoryId == selectedId);
    this.vendorProductForm.patchValue({
      productName: "",
      productId: 0
    })
  }

  productchanged(event: any): void {
    const selectedId = (event.target as HTMLSelectElement).value;
    const selectedItem = this.filteredProductList.find(x => x.ProductId == selectedId);

    this.vendorProductForm.patchValue({
      productCategoryId: selectedItem.ProductCategoryId,
      productCategory: selectedItem.ProductCategory,
      productName: selectedItem.ProductName,
    })
  }

  ChangePriority(product, e) {
    this.loaderIcon = Promise.resolve(true);
    if (product.Priority == true) {
      e.target.checked = true;
      this.toastr.success($localize`already set`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }
    this.VendorProductsList.forEach(x => x.Priority = (x.ProductId == product.ProductId ? true : false));
    this.gridVenProd.refresh();
    this.loaderIcon = Promise.resolve(false);
  }

  deleteVendorProduct(e, product) {
    if (product.Priority == true) {
      this.toastr.error($localize`The primary product cannot be deleted`, $localize`Failed`, this.sharedHTMLSettings.ToasterConfig)
      return;
    }

    e.preventDefault();
    const index = this.VendorProductsList.findIndex(item => item.ProductId == product.ProductId);

    if (index === -1) {
      return;
    }

    const deletedProduct = { ...this.VendorProductsList[index] };
    this.VendorProductsList.splice(index, 1);
    this.VendorProductsList = [...this.VendorProductsList];
    this.gridVenProd.dataSource = this.VendorProductsList;
    this.gridVenProd.refresh();

    if (this.VId != 0) {
      this.saveVendorProductAdded(deletedProduct, index);
    } else {
      this.toastr.success($localize`Product removed from list`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
    }
  }

  VendorPhotoUpload(event: any): void {
    this.vendorProfileChanged = true;
    var imgSize;

    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {

      imgSize = this.formatFileSize(event.target.files[0].size, 2);
      const fileSizeInKB = event.target.files[0].size / 1024;

      if (fileSizeInKB <= 1024) {
        if (imgSize.toString().substring(imgSize.toString().length - 2, imgSize.toString().length) == 'KB') {
          const file = event.target.files[0];
          reader.readAsDataURL(file);
          reader.onload = () => {
            const imageExtension = file.name.substr(file.name.lastIndexOf('.') + 1);
            const fileName = file.type;
            this.imageUrl = reader.result;
            this.imageBase64 = reader.result.toString().split(',')[1];

            this.vendorForm.patchValue({
              venTxtPhotoFile: this.imageBase64,
              vendorProfile: this.imageUrl
            });
          };
        } else {
          this.imageUrl = '../../../assets/images/NoImage.jpg';
          this.imageBase64 = "";
        }
      } else {
        this.toastr.info($localize`Image size exceeded 1mb`, $localize`Not allowed`, this.sharedHTMLSettings.ToasterConfig);
        this.loaderIcon = Promise.resolve(false);
        this.resetVendorFileInput();
        return;
      }
    } else {
      this.toastr.error($localize`Please select a valid image file`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
    }
  }

  formatFileSize(bytes, decimalPoint) {
    if (bytes == 0) return '0 Bytes';
    var k = 1000,
      dm = decimalPoint || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  resetVendorFileInput() {
    // Reset file input to allow selecting the same file again
    const fileInput: HTMLInputElement = document.getElementById('fileVendorPhoto') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = ''; // Reset file input value
    }
  }

  UpdateVendor(e: any): void {
    e.preventDefault();

    // if(this.VId != 0 && !this.editRight){
    //   this.toastr.error($localize`You do not have access to edit vendor`,$localize`access denied`, this.sharedHTMLSettings.ToasterConfig)
    //   this.loaderIcon = Promise.resolve(false);
    //   return;
    // }else if( !this.createRight){
    //   this.toastr.error($localize`You do not have access to create vendor`,$localize`access denied`, this.sharedHTMLSettings.ToasterConfig)
    //   this.loaderIcon = Promise.resolve(false);
    //   return;
    // }

    if (this.vendorForm.value['firstName']?.trim() == "") {
      this.toastr.error($localize`Vendor first name can't be empty`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    const allowWebInquiry = this.vendorForm.get('AllowWebInquiry')?.value;
    const emailControl = this.vendorForm.get('email');
    const email = emailControl?.value?.trim();

    if ((email && emailControl?.invalid) || (allowWebInquiry && !email)) {
      this.toastr.info(
        allowWebInquiry && !email
          ? $localize`Web Inquiry is enabled for this vendor. Please enter a valid email address before saving.`
          : $localize`Please enter a valid email address.`,
        $localize`Info`,
        this.sharedHTMLSettings.ToasterConfig
      );

      this.loaderIcon = Promise.resolve(false);
      return;
    }

    // if (this.vendorForm.get('ApplyFlatCommissionPos').value == true && (this.vendorForm.get('FlatCommissionPos').value == '' || this.vendorForm.get('FlatCommissionPos').value == '0')) {
    //   this.toastr.info($localize`Please enter flat commission value`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
    //   this.loaderIcon = Promise.resolve(false);
    //   return;
    // }
    // if (this.vendorForm.get('EnableConsignmentCommission').value == true && (this.vendorForm.get('ConsignmentCommission').value == '' || this.vendorForm.get('ConsignmentCommission').value == '0')) {
    //   this.toastr.info($localize`Please enter consignment commission value`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
    //   this.loaderIcon = Promise.resolve(false);
    //   return;
    // }

    this.vendorForm.patchValue({
      VendorId: this.VId
    });
    if (this.validateForm()) {
      if (this.vendorForm.valid) {
        if (this.VendorProductsList.length == 0) {
          this.toastr.error($localize`At least 1 product required`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
          this.loaderIcon = Promise.resolve(false);
          return;
        }
        const vendorinfo: IVendorFormOnly = {
          Address: this.vendorForm.get('address')?.value ?? '',
          Address2: this.vendorForm.get('address2')?.value ?? '',
          CellPhone: this.vendorForm.get('cellPhone')?.value ?? '',
          City: this.vendorForm.get('city')?.value ?? '',
          CompanyName: this.vendorForm.get('companyName')?.value ?? '',
          Country: this.vendorForm.get('country')?.value ?? '',
          CountryCode: this.vendorForm.get('countryCode')?.value ?? '',
          DLExpiryDate: this.vendorForm.get('DLexpiryDate')?.value ?? null,
          DriverLicenseNumber: this.vendorForm.get('driverLicense')?.value ?? '',
          Email: this.vendorForm.get('email')?.value ?? '',
          FirstName: this.vendorForm.get('firstName')?.value ?? '',
          LastName: this.vendorForm.get('lastName')?.value ?? '',
          MarketId: this.vendorForm.get('marketId')?.value ?? 0,
          MarketVendorId: this.vendorForm.get('marketVendorId')?.value ?? '',
          MiddleName: this.vendorForm.get('middleName')?.value ?? '',
          State: this.vendorForm.get('state')?.value ?? '',
          VendorId: this.vendorForm.get('vendorId')?.value ?? 0,
          VendorSince: this.vendorForm.get('vendorSince')?.value ?? null,
          VendorType: this.vendorForm.get('vendorType')?.value ?? '',
          Telephone: this.vendorForm.get('telephone')?.value ?? '',
          WorkPhone: this.vendorForm.get('workPhone')?.value ?? '',
          ZipCode: this.vendorForm.get('zipCode')?.value ?? '',
          VendorProductsList: this.VendorProductsList, // external data
          VendorProfile: this.vendorForm.get('vendorProfile')?.value ?? '',
          VenTxtPhotoFile: this.vendorForm.get('venTxtPhotoFile')?.value ?? '',

          FaceBookId: this.vendorForm.get('facebookID')?.value ?? '',
          LinkedInID: this.vendorForm.get('linkedinID')?.value ?? '',

          ApplyFlatCommissionPos: this.vendorForm.get('ApplyFlatCommissionPos').value,
          EnableConsignmentCommission: this.vendorForm.get('EnableConsignmentCommission').value,
          FlatCommissionPos: this.vendorForm.get('FlatCommissionPos').value,
          ConsignmentCommission: this.vendorForm.get('ConsignmentCommission').value,
          AutoDeductRent: this.vendorForm.get('AutoDeductRent').value,
        };

        const updateModel = {
          VendorId: this.VId,
          FlatCommission: Number(this.vendorForm.get('FlatCommissionPos')?.value),
          UpdatePosInvoiceItems: false,
          UpdateInventoryItems: false
        };

        const flatCommissionChanged = this.originalFlatCommission !== Number(this.vendorForm.get('FlatCommissionPos')?.value);

        if (this.VId != 0) {
          if (flatCommissionChanged) {
            if (this.hasTransactionsAfterLastPayout) {
              this.showFlatCommissionPopup(vendorinfo, updateModel);
            }
            else if (this.enableInventoryControl && this.hasInventoryTransactions) {
              this.showInventoryPopup(vendorinfo, updateModel);
            }
            else {
              this.saveVendor(vendorinfo, updateModel);
            }
          } else {
            this.saveVendor(vendorinfo, updateModel);
          }

        } else {
          this.loaderIcon = Promise.resolve(true);
          this.subscriptions.push(this.vendorService.SaveVendor(vendorinfo).subscribe((res: any[]) => {
            this.response = res;
            if (this.response.Success) {
              this.toastr.success(this.response.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
              this.vendorForm.reset();
              this.CancelUpdate();
            }
            else {
              this.toastr.error(this.response.Message, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
            }
            this.loaderIcon = Promise.resolve(false);

          }, (err) => {
            this.toastr.error($localize`Something Went Wrong`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
            this.loaderIcon = Promise.resolve(false);
          }));
        }
      } else {
        this.validateForm();
        this.loaderIcon = Promise.resolve(false);
      }
    } else {
      this.loaderIcon = Promise.resolve(false);
    }
  }

  private showFlatCommissionPopup(vendorInfo: IVendorFormOnly, updateModel: any): void {
    Swal.fire({
      title: 'Vendor',
      text: 'Do you want to change the Flat Commission for the current payout period?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(result => {
      updateModel.UpdatePosInvoiceItems = result.isConfirmed;
      if (this.enableInventoryControl && this.hasInventoryTransactions) {
        this.showInventoryPopup(vendorInfo, updateModel);
      } else {
        this.saveVendor(vendorInfo, updateModel);
      }
    });
  }

  private showInventoryPopup(vendorInfo: IVendorFormOnly, updateModel: any): void {
    Swal.fire({
      title: 'Vendor',
      text: 'Do you want to change the Flat Commission for the Existing Inventory Items of this Vendor?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(result => {
      updateModel.UpdateInventoryItems = result.isConfirmed;
      this.saveVendor(vendorInfo, updateModel);
    });
  }

  validateForm(): boolean {
    const missingFields: string[] = [];

    this.mandatoryFields.forEach(field => {
      const control = this.vendorForm.get(field); // Check if form control exists
      if (control != null) {
        if (
          control.value === null ||
          control.value === undefined ||
          (typeof control.value === 'string' && control.value.trim() === '')
        ) {
          missingFields.push(field);
        }
      }
    });

    if (missingFields.length > 0) {
      const message = missingFields.map(f => this.fieldLabels[f] || f).join(', ');
      Swal.fire({
        title: $localize`Please check the Vendor Information`,
        text: message + '\n . Required/Invalid' || $localize`Unknown error`,
        icon: "warning",
        confirmButtonText: $localize`OK`,
      });
      return false;
    }

    return true;
  }

  private saveVendor(vendorInfo: IVendorFormOnly, updateModel: any): void {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(
      this.vendorService.UpdateVendor(vendorInfo).subscribe(
        (res: any) => {
          this.response = res;
          if (this.response.Success) {
            if (updateModel.UpdatePosInvoiceItems || updateModel.UpdateInventoryItems) {
              this.updateFlatCommission(updateModel);
            }
            this.toastr.info(this.response.Message, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            this.vendorForm.reset();
            this.CancelUpdate();
          } else {
            this.toastr.error(this.response.Message, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          }
          this.loaderIcon = Promise.resolve(false);
        },
        (err) => {
          this.toastr.error($localize`Something Went Wrong`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          this.loaderIcon = Promise.resolve(false);
        }
      )
    );
  }

  private updateFlatCommission(updateModel: any): void {

    this.subscriptions.push(
      this.vendorService.UpdateVendorFlatCommission(updateModel)
        .subscribe({
          next: (res: any) => {

            if (res.Success) {
              this.toastr.success($localize`Flat commission updated successfully.`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            } else {
              this.toastr.error(res.Message, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
            }

          },
          error: () => {
            this.toastr.error($localize`Something Went Wrong`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          }
        })
    );
  }

  CancelUpdate() {
    if (this.VId == 0) {
      const url = '/ops/vendors';
      this.router.navigate([url]);
    } else {
      this.isFormDirty.emit(false);
      this.CancelView.emit(false);
    }
  }

  getVendorGeneralSettings() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.vendorSettingService.getCurrentMarketVendorGeneralSettings().subscribe((res: any) => {

      if (res) {
        this.VendorGeneralSetting = {
          IsVendorIdManual: res.SpecifyVendorID,
          DefaultProductEnabled: res.DefaultProductSelected,
          Product: res.ProductId,
          VendorNameFormat: res.VendorNamingConvention,
          VendorNameFormatId: res.VendorNamingConventionId,
          BoothTerm: res.BoothTerm,
          VendorAddressMandatory: res.VendAddressMandatory,
        }

        if (this.VendorGeneralSetting.VendorAddressMandatory) {

          this.vendorForm.get('City').setValidators([Validators.required]);
          this.vendorForm.get('zipCode').setValidators([Validators.required]);
          this.vendorForm.get('State').setValidators([Validators.required]);

          this.vendorForm.get('City').updateValueAndValidity();
          this.vendorForm.get('zipCode').updateValueAndValidity();
          this.vendorForm.get('State').updateValueAndValidity();
        }

        if (this.VId != 0) {
          this.vendorForm.get('marketVendorId').disable();
          this.IsManualVendorId = false;
        } else {
          this.IsManualVendorId = true;
        }

      }
      this.loaderIcon = Promise.resolve(false);
    }));
    this.loaderIcon = Promise.resolve(false);

  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (!/[0-9.]|\b/.test(event.key)) {
      event.preventDefault();
      return;
    }

    if (event.key === '.' && value.includes('.')) {
      event.preventDefault();
      return;
    }

    const decimalIndex = value.indexOf('.');
    if (decimalIndex >= 0 && value.split('.')[1].length >= 2 && input.selectionStart! > decimalIndex) {
      event.preventDefault();
    }
  }

  // fillZeroIfEmpty(controlName: string) {
  //   const control = this.vendorForm.get(controlName);
  //   if (control && control.value === '') {
  //     control.setValue('0');
  //   }
  // }
  fillZeroIfEmpty(controlName: string) {
    const control = this.vendorForm.get(controlName);
    if (!control) return;
    const value = control.value?.toString().trim();
    if (value === '') {
      control.setValue('0.00');
      return;
    }
    if (/\.\d+/.test(value)) {
      return;
    }
    if (!value.includes('.')) {
      control.setValue(value + '.00');
    }
    if (value.includes('.')) {
      control.setValue(value + '00');
    }
  }

  ToggleFlatComm() {
    const control = this.vendorForm.get('FlatCommissionPos');
    console.log(this.defaultPosCommissionSetting);
    if (this.vendorForm.get('ApplyFlatCommissionPos')?.value) {
      control?.enable();
    } else {
      control?.setValue(this.defaultPosCommissionSetting.FlatCommissionPos);
      control?.disable();

      setTimeout(() => {
        const input = document.querySelector<HTMLInputElement>(
          'input[formControlName="FlatCommissionPos"]'
        );
        input?.dispatchEvent(new FocusEvent('blur'));
      });
    }
  }

  ToggleConsComm() {
    const control = this.vendorForm.get('ConsignmentCommission');
    console.log(this.defaultPosCommissionSetting);
    if (this.vendorForm.get('EnableConsignmentCommission')?.value) {
      control?.enable();
    } else {
      control?.setValue(this.defaultPosCommissionSetting.ConsignmentCommission);
      control?.disable();

      setTimeout(() => {
        const input = document.querySelector<HTMLInputElement>(
          'input[formControlName="ConsignmentCommission"]'
        );
        input?.dispatchEvent(new FocusEvent('blur'));
      });
    }
  }

  loadMandatoryFields(): void {
    this.mandatoryFieldService.GetModuleFields(93).subscribe((result: any[]) => {

      this.mandatoryFields = [];

      result.forEach(field => {

        if (!field.Mandatory) {
          return;
        }

        // Special case for Address
        if (field.Name === 'Address, City, State, Zipcode') {
          this.mandatoryFields.push('address', 'city', 'state', 'zipCode');
          return;
        }

        const formControl = Object.keys(this.fieldLabels).find(
          key => this.fieldLabels[key].toLowerCase() === field.Name.toLowerCase()
        );

        if (formControl) {
          this.mandatoryFields.push(formControl);
        }

      });

      // Always mandatory
      if (!this.mandatoryFields.includes('marketVendorId')) {
        this.mandatoryFields.push('marketVendorId');
      }


      this.ResetMandatoryFields();
    });
  }

  isMandatory(field: string): boolean {
    return this.mandatoryFields.includes(field);
  }

  ResetMandatoryFields() {
    Object.keys(this.vendorForm.controls).forEach(key => {
      const control = this.vendorForm.get(key);
      if (!control) return;

      let validators = [];

      // Add required validator if this field is mandatory
      if (this.mandatoryFields.includes(key) || ['firstName', 'marketVendorId', 'vendorType'].includes(key)) {
        validators.push(Validators.required);
        if (!this.mandatoryFields.includes(key)) {
          this.mandatoryFields.push(key);
        }
      }

      // Special case: Email always has pattern validation
      if (key === 'email') {
        validators.push(
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/)
        );
      }

      // Apply validators
      control.addValidators(validators);
      control.updateValueAndValidity();

      // Special rule: If Address is required, also require City, ZipCode, State
      if ((key === 'address' && this.mandatoryFields.includes(key)) && control.hasValidator(Validators.required)) {
        this.IsAddressMandatory = true;
        ['city', 'zipCode', 'state'].forEach(field => {
          const fControl = this.vendorForm.get(field);
          if (fControl && !fControl.hasValidator(Validators.required)) {
            fControl.addValidators(Validators.required);
            fControl.updateValueAndValidity();
            this.mandatoryFields.push(field);
          }
        });
      }

    });
  }


  onBeforeOpen(args: any): void {
    if (!args || !args.target || !args.target.dataset || !args.target.dataset.content) {
      args.cancel = true;
    }
  }

  getDefaultPOSCommissions() {
    this.subscriptions.push(this.PosSettingsService.getDefaultPOSCommissions().subscribe((res: any) => {
      if (res) {
        this.defaultPosCommissionSetting = {
          FlatCommissionPos: res.FlatCommission ?? 0,
          ConsignmentCommission: res.DealerConCommPercent ?? 0,
          AllowCommissionOverride: res.AllowCommissionOverride ?? false
        }

        // Only initialize the form for a new vendor
        if (this.VId === 0) {
          this.vendorForm.patchValue({
            FlatCommissionPos: this.defaultPosCommissionSetting.FlatCommissionPos,
            ConsignmentCommission: this.defaultPosCommissionSetting.ConsignmentCommission
          });
        }

      }
      this.ToggleConsComm();
      this.ToggleFlatComm();
    }
    ));
  }

  zipCodeValidator() {
    let zipCodePattern;
    var countryId = this.vendorForm.value['countryCode'];
    if (countryId == ECountrycode.US) {
      // US Zip Code validation
      zipCodePattern = /^\d{5}(-\d{4})?$/;
    }
    else if (countryId == ECountrycode.CA) {
      // Canada Postal Code validation (e.g., K1A 0B1)
      zipCodePattern = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    }
    // else if (countryId == 2) {
    //   // UK Postcode validation
    //   zipCodePattern = /^(GIR 0AA|[A-PR-UWYZa-pr-uwyz]([0-9]{1,2}|([A-HK-Ya-hk-y][0-9]([0-9ABEHMNPRVWXYabehmnprvwxy])?)|[0-9][A-HJKS-UWa-hjks-uw]) [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/;
    // }

    const zipControl = this.vendorForm.get('zipCode');

    if (!zipControl) {
      return;
    }

    const value = (zipControl.value ?? '').trim();

    // If empty, don't apply format validation.
    // Validators.required will handle the required validation.
    if (!value) {
      const errors = { ...(zipControl.errors || {}) };

      delete errors['invalidZipCode'];

      zipControl.setErrors(
        Object.keys(errors).length > 0 ? errors : null
      );

      return;
    }

    // No pattern for countries other than US/Canada
    if (!zipCodePattern) {
      return;
    }

    if (zipControl.hasValidator(Validators.required)) {
      const isValidZipcode = zipCodePattern.test(value);
      const errors = { ...(zipControl.errors || {}) };

      if (!isValidZipcode) {
        zipControl.setErrors({
          ...errors,
          invalidZipCode: true
        });
      }
      else {
        delete errors['invalidZipCode'];

        zipControl.setErrors(
          Object.keys(errors).length > 0 ? errors : null
        );
      }
    }

  }

  UpdateStateAndCityByZipcode() {

    if ((this.vendorForm.get('state').value == null || this.vendorForm.get('city').value == null) || (this.vendorForm.get('state').value == '' || this.vendorForm.get('city').value == '')) {
      if (this.vendorForm.get('zipCode').value != null && this.vendorForm.get('zipCode').value.trim() != '') {
        this.subscriptions.push(this.vendorService.GetStateAndCityByZipcode(this.vendorForm.get('zipCode').value).subscribe((res: any[]) => {
          this.response = res;
          if (this.response.State != '' || this.response.City != '') {

            this.vendorForm.patchValue({
              state: this.response.State,
              city: this.response.City
            })
          }

        }));
      }
    }
  }

  checkVendorIdExists(): void {
    const vendorId = this.vendorForm.get('marketVendorId')?.value;
    // Only validate for Add New Vendor
    if (!vendorId || this.VId > 0) {
      return;
    }

    this.vendorService.GetVendorByMarketVendorId(vendorId).subscribe({
      next: (response: any) => {
        const vendor = response?.body;
        if (vendor && vendor.VenSeqVendorId > 0) {
          this.vendorForm.get('marketVendorId')?.setValue('');
          this.vendorForm.get('marketVendorId')?.markAsTouched();
          Swal.fire({
            icon: 'warning',
            title: 'Vendor ID already exists!',
            text: 'Please enter a different Vendor ID.'
          }).then(() => {
            this.marketVendorId?.nativeElement.focus();
          });
        }
      },
      error: () => { }
    });
  }

  getASCloudLicenseSettings(): void {
    this.generalService.getASCloudLicenseSettings().subscribe({
      next: (res: any) => {
        this.enableInventoryControl = res?.EnableInventoryControl ?? false;
      },
      error: () => {
        this.enableInventoryControl = false;
      }
    });
  }

  getVendorCommissionUpdateStatus(): void {
    this.vendorService
      .HasVendorTransactionsAfterLastPayout(this.VId)
      .subscribe({
        next: (res: any) => {
          this.hasTransactionsAfterLastPayout = res?.HasTransactionsAfterLastPayout ?? false;
          this.hasInventoryTransactions = res?.HasInventoryTransactions ?? false;
        },
        error: () => {
          this.hasTransactionsAfterLastPayout = false;
          this.hasInventoryTransactions = false;
        }
      });
  }

  allowOnlyAlphaNumericVendorId(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/[^a-zA-Z0-9]/g, '');

    input.value = value;

    this.vendorForm.get('marketVendorId')?.setValue(value, {
      emitEvent: false
    });
  }

  getValidDate(date: any): Date | null {
    if (!date || date.includes('1900')) {
      return null;
    }

    const [year, month, day] = date.substring(0, 10).split('-').map(Number);

    return new Date(year, month - 1, day);
  }

  formatUSZipCode(): void {
    const zipControl = this.vendorForm.get('zipCode');

    if (!zipControl || this.vendorForm.get('countryCode')?.value != 1) {
      return;
    }

    const value = (zipControl.value ?? '').toString().trim();
    const digits = value.replace(/\D/g, '');

    if (digits.length === 9) {
      const formattedZip = `${digits.substring(0, 5)}-${digits.substring(5)}`;

      zipControl.setValue(formattedZip, {
        emitEvent: false
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
